import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { newAuthService } from "Service/Axios";
import { saveUserProfileUrl } from "Constant/api";
import {
  DEFAULT_DOCUMENT_TYPE,
  DEFAULT_MODULE_TYPE,
  DOCUMENT_TYPE_PDF_ONLY,
  VIEW_PROFILE_SECTIONS,
} from "Constant/constants";
import { formatMonthYear, newDownloadFile, uploadHandler } from "Utils";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";

export const Resume = ({ resumeList, fetchData, isCurrentUserProfile }) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e) => {
    setLoading(true);
    const response = await uploadHandler(
      e,
      DEFAULT_MODULE_TYPE.userDocuments,
      DOCUMENT_TYPE_PDF_ONLY
    );
    if (response) {
      onUploadResume(response);
    } else {
      setLoading(false);
    }
  };

  const onUploadResume = async (res) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.resume,
        [VIEW_PROFILE_SECTIONS.resume]: {
          url: res.url,
          appType: res.appType,
          name: res.name,
          size: res.size,
          filetype: res.filetype,
          uploadDate: res.uploadDate,
        },
      };
      setLoading(true);
      const response = await newAuthService(
        saveUserProfileUrl,
        "POST",
        payload
      );
      if (response.status) {
        toast.success(t("common.messages.notification.success.profileUpdated"));
        fetchData();
      } else {
        toast.error(response.message);
      }
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteResume = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.resume,
        [VIEW_PROFILE_SECTIONS.resume]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  const handleDownloadResume = (url) => {
    newDownloadFile(url);
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.resume")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <div className="upload-btn-wrapper rounded-2 cursor-pointer">
                <button
                  className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                  disabled={loading}
                >
                  <input
                    type="file"
                    onChange={handleFileChange}
                    disabled={loading}
                    accept={DEFAULT_DOCUMENT_TYPE[0]}
                  />
                  <i className="bx bx-upload"></i>{" "}
                  {t("auth.viewProfile.uploadResume")}
                </button>
              </div>
            </div>
          )}
        </div>

        <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-2">
          {resumeList && resumeList.length > 0 ? (
            resumeList.map((item, idx) => (
              <li
                key={idx.toString()}
                className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none"
              >
                <div>
                  <h5 className="mb-0 text-sm font-semibold text-primary-800">
                    {item.name}
                  </h5>
                  {item.uploadDate && (
                    <span className="text-xs font-medium text-grey-500">
                      Uploaded on {formatMonthYear(item.uploadDate)}
                    </span>
                  )}
                </div>
                <div className="d-flex align-items-center gap-1">
                  <a
                    href={item.url}
                    target="_blank"
                    className="border-0 bg-transparent text-base text-primary-600 w-8 h-8 d-flex justify-content-center align-items-center text-decoration-none"
                  >
                    <i className="bx bx-show-alt"></i>
                  </a>
                  <button
                    type="button"
                    className="border-0 bg-transparent text-base text-primary-600 w-6 h-6 d-flex justify-content-center align-items-center text-decoration-none"
                    onClick={() => handleDownloadResume(item.url)}
                  >
                    <i className="bx bx-download"></i>
                  </button>
                  {isCurrentUserProfile && (
                    <button
                      type="button"
                      className="border-0 bg-transparent text-base text-primary-600 w-6 h-6 d-flex justify-content-center align-items-center text-decoration-none"
                      onClick={() => handleDeleteResume(item.gid)}
                    >
                      <i className="bx bx-trash"></i>
                    </button>
                  )}
                </div>
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noResume")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};
